import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { MembersPage } from '@/features/members/components';

function MembersRoute(): ReactNode {
  return <MembersPage />;
}

export const Route = createFileRoute('/members')({
  component: MembersRoute,
});
